import * as _ from 'lodash-es';
import type { Reference, StoreObject } from '@apollo/client';
import type { DataKeysForFetchResult, PathsToArrayValues } from './typeUtils';

export type IdentifyFunction = (
  item?: Reference | StoreObject,
) => string | undefined;

const getId: IdentifyFunction = (item) =>
  // @ts-expect-error Should use cache.identify() instead of relying on id
  item && (typeof item === 'string' ? item : item.id);

function updateApolloListItem<
  QueryType,
  Item extends Reference | StoreObject,
  NewItem extends Item,
>(
  prev: NonNullable<QueryType>,
  targetPath: PathsToArrayValues<QueryType>,
  newItem: NewItem,
  add: boolean,
  identify: IdentifyFunction,
) {
  const list: [Item] = _.get(prev, targetPath);
  if (!list) {
    return prev;
  }

  let isMatched = false;
  const newItemId = identify(newItem);
  const updated = list.map((item) => {
    if (identify(item) === newItemId) {
      if (add) {
        isMatched = true;
        return newItem;
      }
      return null;
    }
    return item;
  });

  if (add && !isMatched) {
    updated.push(newItem);
  }

  return _.setWith(_.clone(prev), targetPath, _.compact(updated), _.clone);
}

export default function updateApolloList<TData, QueryType>(
  prev: QueryType,
  data: TData,
  listPath: PathsToArrayValues<QueryType>,
  itemKey: DataKeysForFetchResult<TData>,
  add = true,
  identify: IdentifyFunction = getId,
) {
  const newItem = data?.[itemKey];
  if (!prev || !newItem) {
    return prev;
  }

  return updateApolloListItem(prev, listPath, newItem, add, identify);
}
